var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4038 9.00098C17.2854 9.00106 18 9.71573 18 10.5973C17.9971 10.8448 17.9495 11.0881 17.8607 11.3086C17.7719 11.5291 17.6444 11.7208 17.488 11.869L12.4942 16.7905C12.3518 16.9265 12.1783 17 12 17C11.8217 17 11.6482 16.9265 11.5058 16.7905L6.512 11.869C6.35557 11.7208 6.22806 11.5291 6.13929 11.3086C6.05053 11.0881 6.00287 10.8448 6 10.5973C6 9.71516 6.71516 9.00007 7.5973 9.00015L16.4038 9.00098Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.431841041da011ab2084d1598fe13e94.svg";
export { ForwardRef as ReactComponent };